import { a as h, r as f, x as p, E as m, c as u } from "../lit-element-8JrrHldg.js";
import { n as l } from "../property-4FoNj0Pi.js";
const v = ":host{font-size:14px!important;line-height:21px!important;font-weight:400!important}:host a{color:var(--item-color)!important;text-decoration:var(--item-decoration)!important}:host a:hover{color:var(--core-color-blue-700)!important;text-decoration:none!important}:host a:active{color:var(--core-color-blue-800)!important;text-decoration:underline!important}:host a:focus-visible{box-shadow:var(--item-focus)!important;outline:none!important}:host span{color:var(--item-color)!important;cursor:default!important}";
var b = Object.defineProperty, d = Object.getOwnPropertyDescriptor, a = (c, o, n, e) => {
  for (var t = e > 1 ? void 0 : e ? d(o, n) : o, s = c.length - 1, i; s >= 0; s--)
    (i = c[s]) && (t = (e ? i(o, n, t) : i(t)) || t);
  return e && t && b(o, n, t), t;
};
let r = class extends f {
  constructor() {
    super(...arguments), this.rel = "noreferrer noopener";
  }
  render() {
    return p`
      ${this.href ? p`
            <a
              href="${this.href}"
              target="${this.target || m}"
              rel=${this.rel || m}
            >
              <slot></slot>
            </a>
          ` : p`<span>
            <slot></slot>
          </span>`}
    `;
  }
};
r.styles = [h(v)];
a([
  l({ type: String })
], r.prototype, "href", 2);
a([
  l({ type: String })
], r.prototype, "target", 2);
a([
  l({ type: String })
], r.prototype, "rel", 2);
r = a([
  u("pwc-breadcrumb-item")
], r);
export {
  r as PwcBreadcrumbItem
};
